import { Check, Loader2, X } from "lucide-react";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

export function ReconcileResultBanner({ result, onDismiss }) {
  if (!result) return null;
  return (
    <Card className="border-none shadow-soft bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-950/20 dark:to-emerald-950/20" data-testid="reconcile-result">
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div>
            <p className="font-semibold text-sm text-green-800 dark:text-green-300 flex items-center gap-2">
              <Check className="w-4 h-4" /> Sincronización con recetas completada
            </p>
            <p className="text-xs text-green-700/80 dark:text-green-400/70 mt-1">
              {result.created_count > 0
                ? `${result.created_count} ingrediente${result.created_count > 1 ? "s" : ""} nuevo${result.created_count > 1 ? "s" : ""} creado${result.created_count > 1 ? "s" : ""} (stock 0, min 1) — `
                : "No faltan ingredientes — "
              }{result.scanned_recipes} recetas y {result.scanned_dishes} platos analizados
            </p>
            {result.created_items?.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mt-2">
                {result.created_items.slice(0, 12).map((item, i) => (
                  <Badge key={i} variant="secondary" className="text-xs">{item.name} ({item.unit})</Badge>
                ))}
                {result.created_items.length > 12 && (
                  <Badge variant="outline" className="text-xs">+{result.created_items.length - 12} mas</Badge>
                )}
              </div>
            )}
            {result.enrichment_launched > 0 && (
              <div className="flex items-center gap-1.5 mt-2 text-xs text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/20 rounded-lg px-2.5 py-1.5 w-fit">
                <Loader2 className="w-3 h-3 animate-spin" />
                IA enriqueciendo {result.enrichment_launched} ingrediente{result.enrichment_launched > 1 ? "s" : ""} — consulta el indicador de IA arriba.
              </div>
            )}
          </div>
          <Button variant="ghost" size="sm" onClick={onDismiss}><X className="w-4 h-4" /></Button>
        </div>
      </CardContent>
    </Card>
  );
}
